var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"v-card-subtitle"},[_vm._v(" "+_vm._s(_vm._f("codeAsString")(_vm.event.code))+" ")]),_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.event.details.info)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }